import React, { useRef, useEffect, useCallback, useState} from 'react';
import Documented from "components/help/Documented.js";
import {PAD_FX} from 'constants/contextual-help.js';
import {
    setSelectedZObject, 
    setEffectCollapsed,
    setDrawingPadEdge} from 'actions/index.js';
import {
    midiEffectOptions,
    effectOptions,
    initializeEffect,
    initializeMidiEffect
}  from 'components/effects/constants.js';
import {useDoubleClick} from "components/hooks/useDoubleClick.js";
import AudioFXMenu from "components/pulled/AudioFXMenu.js";
import {useContextMenu} from "components/dropdowns/useContextMenu.js";
import {connect} from 'react-redux';
import '../../SpatialFx.scss';

const OutputNode = ({
    setDrawingPadEdge,
    containerRef,
    addToBack,
    node,
    sequencerEngine,
    scale=1,
    number,
    hideNumber,
    sequencerScale=1,
    isMidi,
    trackPositions,
    setSelectedZObject,
    isRoot,
    useClick,
    setIsCollapsed,
    isCollapsed
}) => { 
    const ref = useRef(undefined);
    const {onContextMenu, dropdownPos, setDropdownPos} = useContextMenu({ref});

    const _onDoubleClick = useCallback((e) => {
        e.stopPropagation();
        let rack = node.effectRack; 
        if (rack) {
            setIsCollapsed(rack.id, !isCollapsed);
        }
    }, [isCollapsed]);

    const onDoubleClick = useDoubleClick(_onDoubleClick, 250, (e) => {
        if (useClick) {
            onContextMenu(e);
        }
    });

    const dropdownPosRef = useRef({x:0, y:0});

    const onMouseDown = useCallback((e) => {
        let x=e.pageX;
        let y=e.pageY;
        if (isMidi) {
            dropdownPosRef.current.x= x + 100;
        } else {
            dropdownPosRef.current.x= x + 250;
        }
        dropdownPosRef.current.y=y;
        if (isMidi) {
            e.stopPropagation();
            if (node.trackNode) {
                node.sequencerEngine.selectTrack(node.trackNumber);
            }
            let rect = containerRef.current.getBoundingClientRect();
            let x = e.clientX - rect.left;
            let y = e.clientY - rect.top;
            let coords = {
                effect: undefined,
                rack: node.effectRack,
                x1: x,
                y1: y,
                x2: x,
                y2: y
            };
            setDrawingPadEdge(node.subSequence.id, coords);
        }
    }, []);

    let id = 'output-node-' + node.id;
    if (isMidi && node.effectRack) {
        id = 'effect-output-0-' + node.effectRack.id;
    }
    let style = {};
    if (number !== undefined) {
        let t = trackPositions[node.id];
        if (t && t.current) {
            t = t.current;
            style.top = (t.offsetTop + 5);
            if (sequencerScale) {
                style.top *= sequencerScale;
            }
        } else {
            style.top = (number+1)*25*scale;
        }
    }

    let className="output-node";
    if (isCollapsed) {
        className += " collapsed";
    }
    return (
        <Documented
          element={isRoot ? PAD_FX : undefined}
          style={style}
          id={id}
          onClick={onDoubleClick}
          onMouseDown={onMouseDown}
          refObj={ref}
          onContextMenu={onContextMenu}
          className={className}>
          {isCollapsed && !hideNumber && <div className="num-effects">{node.effectRack.effects.length}</div>}
          <AudioFXMenu
            isMidi={isMidi}
            addToBack={!isMidi}
            isRoot={isRoot}
            effectOptions={isMidi ? midiEffectOptions : effectOptions}
            initializeEffect={isMidi ? initializeMidiEffect : initializeEffect}
            setDropdownPos={setDropdownPos}
            dropdownPosRef={dropdownPosRef}
            dropdownPos={dropdownPos}
            node={node.effect || node}/>
        </Documented>
    );
}

const mapStateToProps = (state, props) => {
    return {
        isCollapsed: state.effects.effectCollapsed[props.node.effectRack && props.node.effectRack.id]
    };
};


const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedZObject: x => dispatch(setSelectedZObject(x)),
      setIsCollapsed: (id, c) => dispatch(setEffectCollapsed(id, c)),
      setDrawingPadEdge: (x,y) => dispatch(setDrawingPadEdge(x,y))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OutputNode);
